import React from 'react';
import { RadioOption, RadioProps } from '..';
import { useCustomComponent } from '@/hooks';

export interface RadioInputProps extends RadioProps {
  option: RadioOption;
}
export const InputComponent: React.FC<RadioInputProps> = ({
  name,
  value,
  disabled,
  required,
  onChange,
  onBlur,
  onFocus,
  option,
}) => {
  return (
    <input
      type="radio"
      name={name}
      value={option.value}
      checked={value === option.value}
      disabled={disabled || option.disabled}
      required={required}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      className="peptalk-radio-input"
    />
  );
};

export const Input: React.FC<RadioInputProps> = (props: RadioInputProps) => {
  const Component = useCustomComponent({
    componentName: 'RadioInput',
    Component: InputComponent,
  });

  return <Component {...props} />;
};
